import React from 'react';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import {userInfoSelector} from "../redux/selectors/auth";
import withShipment from "../withShipment";


class CheckIn404 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.matchMedia('(max-width: 800px)').matches,
        };
    }

    render() {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '91vh',
                backgroundColor: '#f4f6f8',
                padding: '0 2rem',
                textAlign: 'center',
            }}>
                <AccessTimeIcon style={{fontSize: 64, color: '#2596be', marginBottom: '1.5rem'}}/>
                <h1 style={{fontSize: '1.9rem', color: '#222', marginBottom: '0.75rem', fontWeight: '600'}}>
                    Welcome, {this.props.user.firstname}!<br/>You're currently not clocked in.
                </h1>
                <p style={{fontSize: '1.1rem', color: '#555', maxWidth: '480px', lineHeight: '1.6'}}>
                    Please scan your Chip to check in and begin your work session.
                </p>
            </div>

        );
    }
}

const mapStateToProps = (state) => ({
    user: userInfoSelector(state),
})


export default withShipment({
    mapStateToProps
}, CheckIn404);